import { render, staticRenderFns } from "./StickersPage.vue?vue&type=template&id=9356dd56&"
import script from "./StickersPage.vue?vue&type=script&lang=js&"
export * from "./StickersPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports